import {
  ASSETS_RECEIVED,
  FETCHING_ASSETS,
  SET_AGGREGATED_FILTERS,
  SET_HUMAN_RESULT,
  SET_HUMAN_RESULTS_SIGNATURE,
  SET_LATEST_FETCH_ID,
  SET_OTHER_MAIN_GROUPS_WITH_RESULTS,
  SET_SEARCH_INSTANCE,
  SET_SEARCH_LOADING,
  SET_SEARCH_VIEW_CONFIG
} from "../actions/asset-search";

const assetSearchReducer = (
  state = {
    instance: null,
    fetchId: null,
    assets: [],
    totalResults: 0,
    humanResults: {},
    humanResultsSignature: null,
    loading: true,
    lastSearchUrl: "",
    aggregatedFilters: [],
    searchViewConfig: {},
    otherMainGroupsWithResults: []
  },
  action
) => {
  switch (action.type) {
    case SET_SEARCH_INSTANCE: {
      return {
        ...state,
        instance: action.value
      };
    }

    case FETCHING_ASSETS: {
      if (action.append || action.prepend) {
        return {
          ...state,
          lastSearchUrl: action.url
        };
      }

      return {
        ...state,
        lastSearchUrl: action.url,
        assets: []
        // humanResults: {}
      };
    }

    case SET_LATEST_FETCH_ID: {
      return {
        ...state,
        fetchId: action.value
      };
    }

    case SET_OTHER_MAIN_GROUPS_WITH_RESULTS: {
      return {
        ...state,
        otherMainGroupsWithResults: action.value
      };
    }

    case ASSETS_RECEIVED: {
      if (action.prepend) {
        return {
          ...state,
          assets: [...action.value.images, ...state.assets],
          totalResults: action.value.numResults
        };
      }

      if (action.append) {
        return {
          ...state,
          assets: [...state.assets, ...action.value.images],
          totalResults: action.value.numResults
        };
      }

      return {
        ...state,
        assets: action.value.images,
        totalResults: action.value.numResults
      };
    }

    case SET_HUMAN_RESULT: {
      return {
        ...state,
        humanResults: {
          ...state.humanResults,
          [action.mainGroup]: action.value
        }
      };
    }

    case SET_HUMAN_RESULTS_SIGNATURE: {
      return {
        ...state,
        humanResultsSignature: action.value
      };
    }

    case SET_AGGREGATED_FILTERS: {
      return {
        ...state,
        aggregatedFilters: action.value
      };
    }

    case SET_SEARCH_VIEW_CONFIG: {
      return {
        ...state,
        searchViewConfig: action.value
      };
    }

    case SET_SEARCH_LOADING: {
      return {
        ...state,
        loading: action.value
      }
    }

    default: {
      return {
        ...state
      };
    }
  }
};

export default assetSearchReducer;
